// The key comes from https://rockzhang.com/keyboard/data.json
const TextValueMapping = [
  {
    "~": "00 35",
    "@2": "00 1f",
    W: "00 1a",
    F2: "00 3b",
    Z: "00 1d",
    CtrlL: "00 e0",
    "Caps Lock": "00 39",
    Tab: "00 2b",
    "!1": "00 1e",
    Esc: "00 29",
    F1: "00 3a",
    S: "00 16",
    WinL: "00 e3",
    ShiftL: "00 e1",
    A: "00 04",
    Q: "00 14",
    E: "00 08",
    $4: "00 21",
    R: "00 15",
    "%5": "00 22",
    F5: "00 3e",
    Spacebar: "00 2c",
    C: "00 06",
    D: "00 07",
    "#3": "00 20",
    F3: "00 3c",
    F4: "00 3d",
    T: "00 17",
    F: "00 09",
    V: "00 19",
    AltL: "00 e2",
    X: "00 1b",
    "^6": "00 23",
    F6: "00 3f",
    U: "00 18",
    F8: "00 41",
    K: "00 0e",
    M: "00 10",
    B: "00 05",
    G: "00 0a",
    "&7": "00 24",
    F7: "00 40",
    "*8": "00 25",
    I: "00 0c",
    J: "00 0d",
    N: "00 11",
    H: "00 0b",
    Y: "00 1c",
    "_-": "00 2d",
    "+=": "00 2e",
    "}]": "00 30",
    LOCK: "00 b2",
    Enter: "00 28",
    ShiftR: "00 e5",
    WinR: "00 e7",
    "\"'": "00 34",
    F11: "00 44",
    F12: "00 45",
    Backspace: "00 2a",
    "|\\": "00 31",
    CtrlR: "00 e4",
    Fn: "52 21",
    "?/": "00 38",
    "{[": "00 2f",
    Del: "00 4c",
    Prtscr: "00 46",
    Home: "00 4a",
    Prtblk: "00 48",
    PgDn: "00 4e",
    Arrowup: "00 52",
    ArrowL: "00 50",
    Insert: "00 49",
    End: "00 4d",
    ScrLk: "00 47",
    PgUp: "00 4b",
    ArrowR: "00 4f",
    ArrowD: "00 51",
    "(9": "00 26",
    F9: "00 42",
    P: "00 13",
    ">.": "00 37",
    "<,": "00 36",
    O: "00 12",
    ")0": "00 27",
    F10: "00 43",
    ":;": "00 33",
    AltR: "00 e6",
    L: "00 0f",
  },
  {
    "~": "00 01",
    "@2": "00 01",
    W: "7f 08",
    F2: "00 b1",
    Z: "7f 0f",
    CtrlL: "7f 0e",
    "Caps Lock": "00 01",
    Tab: "00 01",
    "!1": "00 01",
    Esc: "00 01",
    F1: "00 b3",
    S: "00 01",
    WinL: "7f 04",
    ShiftL: "00 01",
    A: "7f 09",
    Q: "00 01",
    E: "00 01",
    $4: "00 01",
    R: "00 01",
    "%5": "00 01",
    F5: "00 af",
    Spacebar: "00 01",
    C: "00 b2",
    D: "00 01",
    "#3": "00 01",
    F3: "00 b4",
    F4: "00 b5",
    T: "00 01",
    F: "00 01",
    V: "00 01",
    AltL: "7f 11",
    X: "7f 10",
    "^6": "00 01",
    F6: "00 ae",
    U: "00 01",
    F8: "00 ab",
    K: "00 01",
    M: "00 a8",
    B: "00 01",
    G: "00 01",
    "&7": "00 01",
    F7: "00 ac",
    "*8": "00 01",
    I: "00 01",
    J: "00 01",
    N: "00 01",
    H: "00 01",
    Y: "00 01",
    "_-": "78 2a",
    "+=": "78 29",
    "}]": "00 01",
    LOCK: "00 01",
    Enter: "00 01",
    ShiftR: "00 01",
    WinR: "00 01",
    "\"'": "00 01",
    F11: "00 01",
    F12: "00 01",
    Backspace: "00 01",
    "|\\": "78 20",
    CtrlR: "7f 44",
    Fn: "00 01",
    "?/": "00 01",
    "{[": "00 01",
    Del: "78 21",
    Prtscr: "7f 00",
    Home: "00 01",
    Prtblk: "7f 02",
    PgDn: "00 01",
    Arrowup: "78 27",
    ArrowL: "00 01",
    Insert: "00 01",
    End: "00 01",
    ScrLk: "7f 01",
    PgUp: "00 01",
    ArrowR: "00 01",
    ArrowD: "78 28",
    "(9": "00 01",
    F9: "00 01",
    P: "00 01",
    ">.": "00 a9",
    "<,": "00 aa",
    O: "00 01",
    ")0": "00 01",
    F10: "00 01",
    ":;": "00 01",
    AltR: "00 01",
    L: "78 02",
  },
  {
    "~": "00 01",
    "@2": "00 01",
    W: "00 1a",
    F2: "00 bd",
    Z: "00 01",
    CtrlL: "00 01",
    "Caps Lock": "00 01",
    Tab: "00 01",
    "!1": "00 01",
    Esc: "00 01",
    F1: "00 be",
    S: "00 16",
    WinL: "00 e2",
    ShiftL: "00 01",
    A: "00 04",
    Q: "00 01",
    E: "00 01",
    $4: "00 01",
    R: "00 01",
    "%5": "00 01",
    F5: "00 01",
    Spacebar: "00 01",
    C: "00 01",
    D: "00 07",
    "#3": "00 01",
    F3: "00 c1",
    F4: "08 2c",
    T: "00 01",
    F: "00 01",
    V: "00 01",
    AltL: "00 e3",
    X: "00 01",
    "^6": "00 01",
    F6: "00 01",
    U: "00 01",
    F8: "00 ae",
    K: "00 01",
    M: "00 01",
    B: "00 01",
    G: "00 01",
    "&7": "00 01",
    F7: "00 ac",
    "*8": "00 01",
    I: "00 01",
    J: "00 01",
    N: "00 01",
    H: "00 01",
    Y: "00 01",
    "_-": "00 01",
    "+=": "00 01",
    "}]": "00 01",
    LOCK: "00 b2",
    Enter: "00 01",
    ShiftR: "00 01",
    WinR: "00 e6",
    "\"'": "00 01",
    F11: "00 aa",
    F12: "00 a9",
    Backspace: "00 01",
    "|\\": "00 01",
    CtrlR: "00 01",
    Fn: "52 23",
    "?/": "00 01",
    "{[": "00 01",
    Del: "00 01",
    Prtscr: "00 01",
    Home: "00 01",
    Prtblk: "00 01",
    PgDn: "00 01",
    Arrowup: "00 01",
    ArrowL: "00 01",
    Insert: "00 01",
    End: "00 01",
    ScrLk: "00 01",
    PgUp: "00 01",
    ArrowR: "00 01",
    ArrowD: "00 01",
    "(9": "00 01",
    F9: "00 ab",
    P: "00 01",
    ">.": "00 01",
    "<,": "00 01",
    O: "00 01",
    ")0": "00 01",
    F10: "00 a8",
    ":;": "00 01",
    AltR: "00 e7",
    L: "00 01",
  },
  {
    "~": "00 01",
    "@2": "00 01",
    W: "7f 08",
    F2: "00 3b",
    Z: "7f 0f",
    CtrlL: "7f 0e",
    "Caps Lock": "00 01",
    Tab: "00 01",
    "!1": "00 01",
    Esc: "00 01",
    F1: "00 3a",
    S: "00 01",
    WinL: "7f 11",
    ShiftL: "00 01",
    A: "7f 09",
    Q: "00 01",
    E: "00 01",
    $4: "00 01",
    R: "00 01",
    "%5": "00 01",
    F5: "00 3e",
    Spacebar: "00 01",
    C: "00 b2",
    D: "00 01",
    "#3": "00 01",
    F3: "00 3c",
    F4: "00 3d",
    T: "00 01",
    F: "00 01",
    V: "00 01",
    AltL: "00 e3",
    X: "7f 10",
    "^6": "00 01",
    F6: "00 3f",
    U: "00 01",
    F8: "00 41",
    K: "00 01",
    M: "00 a8",
    B: "00 01",
    G: "00 01",
    "&7": "00 01",
    F7: "00 40",
    "*8": "00 01",
    I: "00 01",
    J: "00 01",
    N: "00 01",
    H: "00 01",
    Y: "00 01",
    "_-": "78 2a",
    "+=": "78 29",
    "}]": "00 01",
    LOCK: "00 01",
    Enter: "00 01",
    ShiftR: "00 01",
    WinR: "00 e6",
    "\"'": "00 01",
    F11: "00 44",
    F12: "00 45",
    Backspace: "00 01",
    "|\\": "78 20",
    CtrlR: "00 01",
    Fn: "00 01",
    "?/": "00 01",
    "{[": "00 01",
    Del: "78 21",
    Prtscr: "7f 00",
    Home: "00 01",
    Prtblk: "7f 02",
    PgDn: "00 01",
    Arrowup: "78 27",
    ArrowL: "00 01",
    Insert: "00 01",
    End: "00 01",
    ScrLk: "7f 01",
    PgUp: "00 01",
    ArrowR: "00 01",
    ArrowD: "78 28",
    "(9": "00 01",
    F9: "00 42",
    P: "00 01",
    ">.": "00 a9",
    "<,": "00 aa",
    O: "00 01",
    ")0": "00 01",
    F10: "00 43",
    ":;": "00 01",
    AltR: "00 e7",
    L: "78 02",
  },
];

export default TextValueMapping;
